import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {User} from "../../../objects/user";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {AppEvent} from "../../../objects/appEvent";
import {ListItem} from "../../../objects/listItem";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {SubscriptionLike} from "rxjs";

@Component({
  selector: 'app-cup-player-info-popup',
  templateUrl: './cup-player-info-popup.component.html',
  styleUrls: ['./cup-player-info-popup.component.css']
})
export class CupPlayerInfoPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();

  constructor(public sharedDataService: SharedDataService,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog) { }

  profile: User;
  gameToDisplay: object;
  class: object;
  state = 'default';
  pendingRequest = false;
  justConfirmed = false;
  errMsg = '';
  private sharedEventSubscription: SubscriptionLike;

  ngOnInit(): void {
    this.profile = this.payload['item']['itemFullData'];
    this.gameToDisplay = this.profile['games'].length ? this.profile['games'][0] : null;
    this.class = this.payload['listPayload']['class'];
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.CUP_PLAYER_GAME_STATUS_CHANGED) {
          console.log('AppEvent.CUP_PLAYER_GAME_STATUS_CHANGED','player-info-popup');
          //close popup when other player is in view
          let appProfile = appEvent.data['players'].find(player => player['id'] == this.application.user.id)
          let lastAppProfileGame = appProfile['games'].length ? appProfile['games'][0]['gamePayload'] : null;
          if(!lastAppProfileGame || (lastAppProfileGame['player_id'] != this.profile['id'] && lastAppProfileGame['vizavi_id'] != this.profile['id'])) {
            this.close.emit()
          } else {
            let updatedProfile = appEvent.data['players'].find(player => player.id == this.profile.id);
            this.profile = updatedProfile
            this.gameToDisplay = this.profile['games'].length ? this.profile['games'][0] : null;
            appEvent.data['skip_player_popup_open'] = true;
          }
        }
      });
  }
  ngOnDestroy() {
    this.sharedEventSubscription.unsubscribe();
  }

  public createGameClick(): void {
    console.log('createGameClick')
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('cup_action_start_game_confirmation_title'),
        message: AppComponent.getLabel('cup_action_start_game_confirmation_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          let gamePayload = {};
          let playerProfile = this.payload['listPayload']['players'].find(el => el['itemFullData']['id'] == this.application.user.id)['itemFullData'] as User;
          gamePayload['profiles'] = [playerProfile,this.profile]
          gamePayload['player_id'] = this.application.user.id
          gamePayload['vizavi_id'] = this.profile.id
          //gamePayload['pickedTime'] = ((new Date()).getTime())/1000
          this.pendingRequest = true;
          this.application.apiService
            .cupGameAction(environment['gid'],environment['g_hash'],this.class['id'],gamePayload,'create')
            .subscribe(
              data => this.gameSaved(data),
              error => this.gameError(error))
          dialogRef.close()
        }
      })
  }
  public gameSaved(data,justConfirmed = false): void {
    this.pendingRequest = false;
    this.justConfirmed = justConfirmed;
    this.errMsg = '';
    //let appEvent = new AppEvent(AppEvent.MUTUAL_CUP_GAME_CHANGE,data)
    let appEvent = new AppEvent(AppEvent.CUP_PLAYER_GAME_STATUS_CHANGED,data)
    this.sharedDataService.pushAppEvent(appEvent)
    this.profile = data['players'].find(player => player['id'] == this.profile.id) as User;
    this.gameToDisplay = this.profile['games'][0]
  }

  public enterScoreClick() {
    const commonDialogConf = {
      autoFocus: false,
      panelClass: 'common-dialog'
    }
    let listItem = new ListItem();
    listItem.itemFullData = this.gameToDisplay;
    listItem.itemFullData['payload_parsed'] = this.gameToDisplay['gamePayload']
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      ...commonDialogConf,
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'cup-game-open',
        payload: {item: listItem, mode: 'edit_game', users: []},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        console.log('this.gameToDisplay',this.gameToDisplay)
        if(dialogPayload) {
          console.log('dialogPayload',dialogPayload)
          let gamePayload = this.gameToDisplay['gamePayload']
          gamePayload['status'] = 'score_confirmation';
          gamePayload['score'] = dialogPayload['score'];
          this.pendingRequest = true;
          this.application.apiService
            .cupGameAction(environment['gid'],environment['g_hash'],this.class['id'],gamePayload,'score_confirmation',this.gameToDisplay['id'])
            .subscribe(
              data => this.gameSaved(data),
              error => this.gameError(error))
        }
      })
  }

  public confirmScoreClick() {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('cup_action_confirm_game_confirmation_title'),
        message: AppComponent.getLabel('cup_action_confirm_game_confirmation_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          let gamePayload = this.gameToDisplay['gamePayload']
          gamePayload['status'] = 'confirmed';
          this.pendingRequest = true;
          this.application.apiService
            .cupGameAction(environment['gid'],environment['g_hash'],this.class['id'],gamePayload,'confirmed',this.gameToDisplay['id'])
            .subscribe(
              data => this.gameSaved(data,true),
              error => this.gameError(error))
          dialogRef.close()
        }
      })
  }
  public walkoverClick() {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('cup_action_confirm_game_walkover_title'),
        message: AppComponent.getLabel('cup_action_confirm_game_walkover_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          let gamePayload = this.gameToDisplay['gamePayload']
          gamePayload['status'] = 'walkover';
          this.pendingRequest = true;
          this.application.apiService
            .cupGameAction(environment['gid'],environment['g_hash'],this.class['id'],gamePayload,'walkover',this.gameToDisplay['id'])
            .subscribe(
              data => this.gameSaved(data,true),
              error => this.gameError(error))
          dialogRef.close()
        }
      })
  }

  public gameError(error): void {
    this.pendingRequest = false;
    this.errMsg = error.errMsg;
  }

  public onNoClick(): void {
    //this.dialogRef.close();
    this.close.emit()
  }
}
